<template>
  <div class="commission-details" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">余额变动记录</div>
          <!-- <div class="money">
            ￥<span class="num">{{ userInfo.agent_now_money }}</span>
          </div> -->
        </div>

        
        <div class="iconfont icon-jinbi1"></div>
      </div>
    </div>
    <div class="sign-record" ref="content">
      <div class="list">
        <div class="item" v-for="(item, index) in info" :key="index">
      
          <div class="listn">
            <div class="itemn acea-row row-between-wrapper">
              <div>
                <!-- <div class="name line1">{{ item.title }}</div> -->
                <div>
                  {{ item.mark }}
                </div>
                <div>{{ item.add_time }}</div>
              </div>
              <div style="text-align: right;">
                
                <div class="num" v-if="item.pm == 1">+¥{{ item.number }}</div>
                <div class="num font-color-red" v-if="item.pm == 0">
                  -¥{{ item.number }}
                </div>
                <div>¥{{ item.balance }}</div>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getCommissionInfo, getSpreadInfo  ,getAgentBalanceList } from "@/api/user";
import Loading from "@components/Loading";
import { userInfo } from "os";

export default {
  name: "CashRecord",
  components: {
    Loading
  },
  props: {},
  data: function() {
    return {
      info: [],
      extractCount: 0,
      where: {
        page: 1,
        limit: 11
      },
      types: 4,
      loaded: false,
      loading: false
    };
  },
  mounted: function() {
    // this.getCommission();
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      this.loading === false && this.getIndex();
    });
  },
  methods: {
   
    getIndex: function() {
      let that = this;
      if (that.loading == true || that.loaded == true) return;
      that.loading = true;
      getAgentBalanceList(that.where.page, that.where.limit).then(
        res => {
          that.loading = false;
          that.loaded = res.data.length < that.where.limit;
          that.where.page = that.where.page + 1;
          that.info.push.apply(that.info, res.data);
        },
        error => {
          that.$dialog.message(error.msg);
        }
      );
    },
    getCommission: function() {
      let that = this;
      getSpreadInfo().then(
        res => {
          that.extractCount = res.data.extractCount;
        },
        error => {
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
